import { useNormalizedComposers } from './useNormalizedComposers';
import { useSortedRows } from './useSortedRows';
function useSortComposers(options) {
    const { composers, currentPlan, sortId, sortOrder } = options;
    const rows = useNormalizedComposers(composers, currentPlan);
    const sortedRows = useSortedRows({ rows, sortId, sortOrder });
    return sortedRows;
}
export { useSortComposers };
